import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { preprocessTextAsyncAutocompleteField } from "@/features/FormCard/utils";
import { createCurrencyOption } from "@/hooks/useCurrencyOption";
import { z } from "zod";
import { DEFAULT_ASSET_CLASS_OPTIONS } from "./edit-form-conf";
import { DepField, makeFiltersBuilder } from "@/features/FilterTable/utils";

const filterC8StaticDatumsSchema = z.object({
  name_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional(),
  isin_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional(),
  code_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional(),
  currency_contains: z.string().optional(),
  asset_class_1_contains: z.string().optional(),
  asset_class_2_contains: z.string().optional(),
});

export type FilterC8StaticDatumsSchema = z.infer<
  typeof filterC8StaticDatumsSchema
>;

const assetDepFields: readonly DepField<FilterC8StaticDatumsSchema>[] = [
  {
    name: "name_contains",
    key: "id",
    extract: "id",
    bucket: "equals",
  },
  { name: "isin_contains", key: "isin", extract: "text", bucket: "equals" },
];

const fields: Field[] = [
  {
    name: "name_contains",
    label: `Nom`,
    type: "asyncAutocomplete",
    base_url: "c8/c8_static_data",
    column_name: "name",
    filters: makeFiltersBuilder<FilterC8StaticDatumsSchema>(
      assetDepFields,
      "name_contains",
    ),
  },
  {
    name: "isin_contains",
    label: `ISIN`,
    type: "asyncAutocomplete",
    base_url: "c8/c8_static_data",
    column_name: "isin",
    filters: makeFiltersBuilder<FilterC8StaticDatumsSchema>(
      assetDepFields,
      "isin_contains",
    ),
  },
  {
    name: "currency_contains",
    label: `Devise`,
    type: "autocomplete",
    options: createCurrencyOption(),
  },
  {
    name: "asset_class_1_contains",
    label: `Classe d'actifs`,
    type: "select",
    useTranslation: true,
    client: "c8",
    table_name: "c8_static_data",
    language: "fr",
    translate_key: "asset_class_1",
  },
  {
    name: "asset_class_2_contains",
    label: `Sous-classe d'actifs`,
    type: "sectionSelect",
    useTranslation: true,
    useTransactionForSectionName: true,
    section_name_translation_key: "asset_class_1",
    section_name_table_name: "c8_static_data",
    client: "c8",
    table_name: "c8_static_data",
    language: "fr",
    translate_key: "asset_class_2",
    options: DEFAULT_ASSET_CLASS_OPTIONS,
  },
];

export function FilterC8StaticDatums() {
  return (
    <FilterTable
      schema={filterC8StaticDatumsSchema}
      client="c8"
      tableName="c8_static_data"
      fields={fields}
    />
  );
}
